import { XIcon } from 'lucide-react'

import { CarrierBrandingProvider, CoBrandedHeader, useCarrierBranding } from 'components/carrier_branding'

type Props = {
  logoUrl?: string
  closeUrl?: string
  prospectState?: string | null
}

function TopBarContent ({ logoUrl, closeUrl }: { logoUrl?: string, closeUrl?: string }) {
  const branding = useCarrierBranding()

  if (branding?.isLoading) {
    return null
  }

  const logo = branding?.hasCarrierBranding
    ? <CoBrandedHeader />
    : <img src={logoUrl ?? RAILS_ASSET_URL('logo_with_name.png')} alt='Thatch' className='h-6' />

  return (
    <div className='h-[72px] flex flex-row items-center justify-end gap-4 px-[80px] border-b border-gray-200'>
      {logo}
      {closeUrl && (
        <a href={closeUrl} className='text-gray-400 hover:text-gray-600'>
          <XIcon className='h-5 w-5' />
        </a>
      )}
    </div>
  )
}

export function QuoteFlowTopNav ({ logoUrl, closeUrl, prospectState }: Props) {
  return (
    <CarrierBrandingProvider state={prospectState ?? undefined}>
      <TopBarContent logoUrl={logoUrl} closeUrl={closeUrl} />
    </CarrierBrandingProvider>
  )
}
